// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  name: __t.string(),
  ownerId: __t.string().name("owner_id"),
  customerId: __t.string().name("customer_id"),
  logo: __t.string(),
  isGlaciEnabled: __t.option(__t.bool()).name("is_glaci_enabled"),
  isInGracePeriod: __t.option(__t.bool()).name("is_in_grace_period"),
  hasRequestedGlaciAccess: __t.option(__t.bool()).name("has_requested_glaci_access"),
  runtimeUri: __t.option(__t.string()).name("runtime_uri"),
  runtimeModule: __t.option(__t.string()).name("runtime_module"),
  glaciContextCatalog: __t.option(__t.string()).name("glaci_context_catalog"),
  glaciFeatures: __t.option(__t.string()).name("glaci_features"),
  glaciInstances: __t.option(__t.string()).name("glaci_instances"),
  glaciBranding: __t.option(__t.string()).name("glaci_branding"),
  glaciCredentialMetadata: __t.option(__t.string()).name("glaci_credential_metadata"),
  createdAt: __t.option(__t.timestamp()).name("created_at"),
  updatedAt: __t.option(__t.timestamp()).name("updated_at"),
});
